import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(isoWeek)
dayjs.extend(advancedFormat)
dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)

let appTimezone: string = dayjs.tz.guess()

export const isValidTimezone = (tz: string | null | undefined): tz is string => {
  if (!tz) return false
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz })

    return true
  } catch {
    return false
  }
}

export const setAppTimezone = (tz: string | null | undefined) => {
  if (!isValidTimezone(tz)) {
    if (tz) console.warn('Invalid timezone')

    return
  }
  appTimezone = tz
}

export const getAppTimezone = () => appTimezone

export { dayjs }
